import { createEventBus } from "@dd-code/jt-event-bus";

import type { RequestHttpEventMap } from "./types";

/**
 * request-http 共享事件总线：
 * - 只创建一次，供 createAxios 默认复用
 * - 外部也可直接导入该实例进行订阅
 */
export const requestHttpBus = createEventBus<RequestHttpEventMap>();
